import React from 'react'
import FormErrorMessage from 'components/form-components/FormErrorMessage'
import FormSuccessMessage from 'components/form-components/FormSuccessMessage'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StatusErrorMessage = styled(FormErrorMessage)`
  font-size: 16px;
`

const FormStatus = ({ dirty, status }) => (
  <>
    {status && status.submitError && (
      <StatusErrorMessage>{status.submitError}</StatusErrorMessage>
    )}
    {status && status.submitSuccess && !dirty && (
      <FormSuccessMessage>{status.submitSuccess}</FormSuccessMessage>
    )}
  </>
)

FormStatus.propTypes = {
  dirty: PropTypes.bool,
  status: PropTypes.any,
}

export default FormStatus
